import React from 'react';
import { SentryErrorBoundary } from '../../../../../services/SentryService';
import { ActionCardErrorFallback } from './ActionCardErrorFallback';
import { BaseAction } from '../../../types';

interface ActionCardErrorBoundaryProps {
  children: React.ReactNode;
  appointment: BaseAction;
}

/**
 * ActionCardErrorBoundary wraps a specific action card component with Sentry error
 * handling and reporting. It uses environment-specific fallback UIs and provides
 * detailed error context to Sentry.
 */
export const ActionCardErrorBoundary: React.FC<ActionCardErrorBoundaryProps> = ({
  children,
  appointment,
}) => {
  return (
    <SentryErrorBoundary
      fallback={ActionCardErrorFallback}
      beforeCapture={scope => {
        // Add component identification
        scope.setTag('component', 'ActionCard');

        // Add action-specific tags for filtering in Sentry
        scope.setTag('action_id', appointment.action_id);
        scope.setTag('action_type', appointment.action_type);

        // Add detailed action context for debugging
        scope.setContext('action', {
          action_id: appointment.action_id,
          action_type: appointment.action_type,
          patient_id: appointment.patient?.patient_id || 'unknown',
          encounter_id: appointment.encounter_id || 'unknown',
        });
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
};
